module.exports = __webpack_public_path__ + "img/guide01.24d0f7a2.jpg";